<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="mES_TeamShiftRotas"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="排班月份">
            <el-date-picker
                v-model="filter.rotaMonth"
                type="month"
                value-format="yyyy-MM"
                style="width: 150px"
                clearable
                placeholder="请选择月份"/>
          </el-form-item>
          <el-form-item label="员工工号">
            <el-input v-model.trim="filter.empNo" placeholder="请输入员工工号" clearable/>
          </el-form-item>
          <el-form-item label="员工姓名">
            <el-input v-model.trim="filter.empName" placeholder="请输入员工姓名" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <team-shift-rota-edit ref="teamShiftRotaEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import TeamShiftRotaEdit from "./TeamShiftRotaEdit";

  export default {
    name: "TeamShiftRotaList",
    components: { TeamShiftRotaEdit, ViewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
        },
        filter: {
          rotaMonth: "",
          empNo: "",
          empName: "",
        },
        columnsProperty: [
          { tooltip: true, key: "teamName", width: 160 },
          { tooltip: true, key: "calendarName", width: 140 },
          { tooltip: true, key: "rotaMonth", align: "center", width: 110 },
          { tooltip: true, key: "rotaDate", align: "center", width: 110 },
          { tooltip: true, key: "empNo", align: "center", width: 120 },
          { tooltip: true, key: "empName", align: "center", width: 110 },
          { tooltip: true, key: "postTypeName", align: "center", width: 110 },
          { tooltip: true, key: "empTypeName", align: "center", width: 120 },
          { tooltip: true, key: "shiftName", align: "center", width: 120 },
          { key: "workStart", align: "center", width: 100 },
          { key: "workEnd", align: "center", width: 100 },
          { key: "restStart", align: "center", width: 100 },
          { key: "restEnd", align: "center", width: 100 },
          { key: "standardWorkHour", align: "center", width: 100 },
          { tooltip: true, key: "canOvertimeName", align: "center", width: 110 },
          { key: "overtimeMaxHour", align: "center", width: 110 },
          { tooltip: true, key: "isBorrowName", align: "center", width: 120 },
          { tooltip: true, key: "remark", width: 150 },
          { tooltip: true, key: "createTime", align: "center", width: 150 },
          { key: "action", width: 140, slot: "action", fixed: "right" },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      addEditHandle(row) {
        if (row && row.id) {
          // 编辑：打开编辑弹窗
          this.$refs.teamShiftRotaEdit.open(row);
        } else {
          // 新建：跳转到批量生成页
          this.$router.push({ name: "TeamShiftRotaGenerate" });
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "mES_TeamShiftRotas", row.id).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
